import MagazineComponent from '@pixum/magazine';
import ThemeProvider from '@pixum/theme-provider';
import { SkeletonTitle, SkeletonText, SkeletonImage } from '@pixum/skeleton';
import { THEME_DEFAULT_PROPS } from 'data-layer/constants';
import { getMagazineVariant } from '../../magazineCollection/utils';

/**
 * DownloadStepsSkeleton Component
 *
 * Displays a loading skeleton while the server-side DownloadSteps component
 * is being rendered. Shows a single magazine skeleton with default theme.
 *
 * This component is used within a Suspense boundary to provide immediate
 * feedback to users while the user agent is being detected and download
 * steps are being filtered server-side.
 */
export function DownloadStepsSkeleton() {
  const magazineTheme = THEME_DEFAULT_PROPS;

  const skeletonText = (
    <div role="status" aria-busy="true">
      <SkeletonText lines={1} aria-hidden="true" />
      <SkeletonTitle size="large" aria-hidden="true" style={{ marginBottom: '16px' }} />
      <SkeletonText lines={3} aria-hidden="true" />
    </div>
  );

  const skeletonMedia = <SkeletonImage aria-hidden="true" />;

  return (
    <ThemeProvider theme={magazineTheme}>
      <MagazineComponent
        contentVariant={getMagazineVariant(0)}
        theme={magazineTheme}
        text={skeletonText}
        media={skeletonMedia}
      />
    </ThemeProvider>
  );
}
